module.exports = "/images/vendor/jquery-ui/themes/base/ui-icons_777777_256x240.png?5e7882c25f80ead21c4b7fa3d8e7c1a3";